import React from 'react';
import { Image as SemanticImage } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export const iconPath = `${process.env.REACT_APP_PUBLIC_URL}/assets/img`;

export function Image({
  name,
  className = '',
  alt = '',
  size = null,
  ...extraProps
}) {
  return (
    <SemanticImage
      src={name ? `${iconPath}/${name}` : extraProps.image}
      alt={alt}
      className={className}
      size={size}
      name={name}
      loading='lazy'
      {...extraProps}
    />
  );
}

Image.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  extraProps: PropTypes.node,
  size: PropTypes.oneOf([
    'mini',
    'tiny',
    'small',
    'medium',
    'large',
    'big',
    'huge',
    'massive',
  ]),
};
